// Libs
import type React from "react";

// Utils
import { useTranslation } from "src/design-system/core/TranslationContext";
import { ADMIN_LAYOUT_TK } from "src/layouts/AdminLayout/config";
import { PATH_SUPERADMIN } from "src/routesConstants";
import { ADMIN_TRANSLATION_NAMESPACE } from "src/views/admin/config";

// Components
import { BiBuilding, BiSolidCat, BiStore, BiUser, BiUserPlus } from "react-icons/bi";
import { PosGroupIcon } from "src/components/generics/icons/PosGroupIcon";
import { SideMenuAWithNavBarLayout } from "src/layouts/SideMenuWithNavBarLayout/SideMenuWithNavBarLayout";
import type { NavBarSection } from "../SharedLayout/NavBar";

interface AdminLayoutProps {
    children?: React.ReactNode;
}

export function AdminLayout({ children }: AdminLayoutProps): JSX.Element {
    const { t } = useTranslation(`${ADMIN_TRANSLATION_NAMESPACE}:${ADMIN_LAYOUT_TK}`);

    const sections: NavBarSection[] = [
        {
            items: [
                {
                    title: t("organizations"),
                    icon: BiBuilding,
                    href: `${PATH_SUPERADMIN}/organization`,
                },
                {
                    title: t("pos"),
                    icon: BiStore,
                    href: `${PATH_SUPERADMIN}/pos`,
                },
                {
                    title: t("groups"),
                    icon: PosGroupIcon,
                    href: `${PATH_SUPERADMIN}/pos-group`,
                },
                {
                    title: t("users"),
                    icon: BiUser,
                    href: `${PATH_SUPERADMIN}/user`,
                },
                {
                    title: t("account-creation"),
                    icon: BiUserPlus,
                    href: `${PATH_SUPERADMIN}/account-creation`,
                },
                {
                    title: t("non-reg"),
                    icon: BiSolidCat,
                    href: `${PATH_SUPERADMIN}/non-reg`,
                    isProdAccessDisallowed: true,
                },
            ],
        },
    ];
    return (
        <SideMenuAWithNavBarLayout sections={sections} isAdmin>
            {children}
        </SideMenuAWithNavBarLayout>
    );
}
